export enum SubscriptionStatus {
  TRIAL = "TRIAL",
  ACTIVE = "ACTIVE",
  PAST_DUE = "PAST_DUE",
  CANCELED = "CANCELED",
}

export enum SubscriptionBillingCycle {
  MONTHLY = "monthly",
  ANNUAL = "annual",
}

export enum SubscriptionAccessMode {
  ACTIVE = "active",
  VIEW_ONLY = "view_only",
  COMPLETE_EXISTING = "complete_existing",
  BLOCKED = "blocked",
}

export enum SubscriptionStatusOrigin {
  WEBHOOK = "webhook",
  SYNC = "sync",
  USER_ACTION = "acao_usuario",
  SYSTEM = "sistema",
}
